module.exports = __webpack_public_path__ + "img/bg1.70a47614.png";